var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card mb-2 p-2" }, [
    _c("div", [
      _vm.directChannel.numUnreadMessages
        ? _c("span", { staticClass: "badge bg-danger float-end" }, [
            _vm._v(_vm._s(_vm.directChannel.numUnreadMessages)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("img", {
        staticClass: "avatar mx-auto",
        attrs: { src: _vm.contact.profile_image },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body text-center" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v(_vm._s(_vm.contactDisplay(_vm.contact))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted" }, [
        _c("small", [_vm._v(_vm._s(_vm.contact.username))]),
      ]),
      _vm._v(" "),
      _vm.contact.job_title
        ? _c("p", { staticClass: "text-muted" }, [
            _c("small", [_vm._v(_vm._s(_vm.contact.job_title))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contact.company_name
        ? _c("p", [
            _vm._v(
              "\n        " + _vm._s(_vm.contact.company_name) + "\n      "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }